__turbopack_context__.v({
  "container": "ImageDivider-module__UCuJlq__container",
});
